<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :loading="isLoading"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center">
        <Button
            btn-class="btn-sm me-2"
            @click.prevent="editRecurrentExpense"
            type="new"
            btn-text="expense.edit"/>
        <Button
            v-if="isActive && $can(abilities.DISABLE_EXPENSE_RECURRING)"
            type="new"
            :is-loading="processing"
            :btn-class="'btn-sm btn-danger'"
            backgroundColor="btn-danger"
            btn-text="recurrentExpense.button.disabled"
            @click.prevent="disableRecurrentExpense"  />
        <Button
            v-else
            v-if="$can(abilities.ACTIVATE_EXPENSE_RECURRING)"
            type="new"
            :is-loading="processing"
            btn-class="btn btn-sm btn-success"
            btn-text="recurrentExpense.button.activated"
            @click.prevent="enableRecurrentExpense" />
        <Button
            icon-class="fas fa-backspace"
            btn-class="btn-sm mb-2"
            type="cancel"
            btn-text="crm.back"
            @click="router.push({ name: 'office-users-expenses-overview', params: { company: currentCompanyId, id: currentRecurrentExpense.office_id } })"/>
      </div>
    </template>
    <template #layoutContent>
      <Loader :isLoading="isLoading">
        <div class="d-flex justify-content-end mb-5 me-1">


        </div>
        <div class="row d-flex flex-wrap px-5">
          <div v-show="false" class="card p-5 mb-4 me-md-5 flex-grow-1 col-12 col-md-3 col-lg-3">
            <Card class="p-5">
              <div class="d-flex justify-content-between align-items-center py-4">
                <span class="fw-bold fs-4"> {{ $t('recurrentExpense.repeatNumber') }} </span>
                <span class="fw-bold fs-4"> 03 </span>
              </div>
              <div class="separator" />
              <div class="d-flex justify-content-between align-items-center py-4">
                <span class="fw-bold fs-4"> {{ $t('recurrentExpense.remainRepeatNumber') }} </span>
                <span class="fw-bold fs-4"> 02 </span>
              </div>
              <div class="separator" />
              <div class="d-flex justify-content-between align-items-center py-4">
                <span class="fw-bold text-primary fs-4"> {{ $t('recurrentExpense.globalAmount') }} </span>
                <span class="fw-bold text-primary fs-4"> {{ $formatLocalAmount("600000") }} FCFA </span>
              </div>
              <div class="separator" />
              <div class="d-flex justify-content-between align-items-center py-4">
                <span class="fw-bold text-primary fs-4"> {{ $t('recurrentExpense.remainToPay') }} </span>
                <span class="fw-bold text-primary fs-4"> {{ $formatLocalAmount("400000") }} FCFA </span>
              </div>
            </Card>
            <Card class="p-5 mt-auto">
              <div class="d-flex justify-content-between align-items-center py-4">
                <span class="fw-bold fs-4"> {{ $t('recurrentExpense.currentAmount') }} </span>
                <span class="fw-bold fs-4"> {{ $formatLocalAmount('200000') }} FCFA </span>
              </div>
              <div class="separator" />
              <div class="d-flex justify-content-between align-items-center py-4">
                <span class="fw-bold text-primary fs-4"> {{ $t('recurrentExpense.remainToPay') }} </span>
                <span class="fw-bold text-primary fs-4"> {{ $formatLocalAmount("2000000") }} FCFA </span>
              </div>
            </Card>
          </div>
          <div class="card card-px-0 px-0 flex-grow-3 flex-md-grow-1 col-12 col-md-3 col-lg-3" style="flex: 1 1 60%;">
            <Show :recurrent-expense="currentRecurrentExpense" :currency="currency"/>
          </div>
        </div>
      </Loader>
    </template>
  </SubLayout>

</template>
<script setup>

import Card from "@/components/Card.vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {computed, onMounted, ref} from "vue";
import {$formatLocalAmount} from "@/mixins/Helpers";
import Loader from "@/components/Loader.vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import abilities from "@/composables/abilities";
import Button from "@/components/Button.vue";
import {useLocales} from "@/composables/locales";
import {useSwal} from "@/composables/useSwal";
import Show from "./components/Show.vue"


const {locale} = useLocales()
const store = useStore()
const router = useRouter()
const route = useRoute()

const {showSwal} = useSwal()

const isLoading = ref(false)
const processing = ref(false)
const title = ref( "breadcrumbs.expense.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.expense.list',
    route: 'expenses',
    params: {}
  },
  {
    name: route.params.id ? 'breadcrumbs.expense.edit' : 'breadcrumbs.expense.new',
    route: route.params.id ? 'expenses-edit' : 'expenses-recurrence-create',
    params: route.params.id ? { id: route.params.id } : { type: route.params.type }
  }
])
const showingAlert = ref(false)

const currentRecurrentExpense = computed(() => store.getters['recurrentExpense/currentRecurrentExpense'])
const currency = computed(() => currentRecurrentExpense.value?.currency?.symbol)
const company = computed(() => store.getters['company/getCompanyInfos'])
const isActive = computed(() => currentRecurrentExpense.value.status)
const currentCompanyId = computed(() => store.getters['offices/getSelectCompanyId'])

function editRecurrentExpense() {
  router.push({ name: 'recurrence-expense-edit', params: {id: route.params.id} })
}

const enableRecurrentExpense = () => {
  showSwal(
      i18n.global.t('recurrentExpense.swal.enabled'),
      i18n.global.t('recurrentExpense.swal.enabled_text'),
  ).then( async (result) => {
    if (result.value) {
      processing.value = true
      store.dispatch('recurrentExpense/enableRecurrentExpense', route.params.id)
          .then(() => {
            loadRecurrentExpense()
            window.toastr['success'](i18n.global.t('recurrentExpense.notification.recurrent_enabled'))
          })
          .catch()
          .finally(() => processing.value = false)
    }
  })

}
const disableRecurrentExpense = () => {
  showSwal(
      i18n.global.t('recurrentExpense.swal.disabled'),
      i18n.global.t('recurrentExpense.swal.disabled_text')
  ).then( async (result) => {
    if (result.value) {
      processing.value = true
      store.dispatch('recurrentExpense/disableRecurrentExpense', route.params.id)
          .then(() => {
            loadRecurrentExpense()
            window.toastr['success'](i18n.global.t('recurrentExpense.notification.recurrent_disabled'))
          })
          .catch()
          .finally(() => processing.value = false)
    }
  })

}
const loadRecurrentExpense = async () => {
  if(route.params.id) {
    await store.dispatch('recurrentExpense/getRecurrentExpenseById', route.params.id)
  }
}

function loadData () {
  isLoading.value = true
  Promise.all([
    store.dispatch('company/generalInformation'),
    loadRecurrentExpense(),
  ]).finally(() => isLoading.value = false)
}

onMounted(() => {
  loadData()
})

function alertDiv(){
  showingAlert.value = true;
  $('#sendModal').modal('toggle')
  setTimeout(() => {
    showingAlert.value = false;
  }, 5000);
}
</script>